import type { ErrorEvent } from "@sentry/react";

const IN_APP_BROWSER_SCHEME = "iabjs://";

export const SENTRY_IGNORE_ERRORS = [
  "window.webkit.messageHandlers",
  "runtime.sendMessage()",
];

export const SENTRY_DENY_URLS = [
  /^chrome-extension:\/\//,
  /^moz-extension:\/\//,
  /^safari-web-extension:\/\//,
];

export const isInAppBrowserEvent = (event: Pick<ErrorEvent, "exception">) =>
  (event.exception?.values ?? []).some((exception) =>
    (exception.stacktrace?.frames ?? []).some(
      (frame) => frame.filename?.startsWith(IN_APP_BROWSER_SCHEME) ?? false,
    ),
  );
